import React, { useState } from "react"
import {
    Box,
    Button,
    Collapse,
    Grid,
    MenuItem,
    Paper,
    TextField,
    Typography,
} from "@material-ui/core"
import { ExpandLess, ExpandMore, Search, Clear } from "@material-ui/icons"
import { makeStyles } from "@material-ui/core/styles"
import { useCartelasFornecedorContext } from "../context/useCartelasFornecedorContext"
import { CartelasFornecedorActionsTypes } from "../context/cartelasFornecedorActions"
import type { FiltroCartelas } from "../../../services/cartelasFornecedor"

const useStyles = makeStyles(theme => ({
    card: {
        borderRadius: 20,
        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
        backgroundColor: "white",
        overflow: "hidden",
        marginBottom: theme.spacing(3),
    },
    cardHeader: {
        backgroundColor: "#f8f9fa",
        padding: theme.spacing(2),
        borderBottom: "2px solid #e9ecef",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        cursor: "pointer",
    },
    cardHeaderTitle: {
        fontWeight: 600,
        color: "#2c3e50",
        fontSize: "0.95rem",
    },
    cardContent: {
        padding: theme.spacing(3),
        [theme.breakpoints.down("sm")]: { padding: theme.spacing(2) },
    },
    botoes: {
        display: "flex",
        justifyContent: "center",
        gap: theme.spacing(2),
        marginTop: theme.spacing(2),
    },
    btnPesquisar: {
        borderRadius: 25,
        backgroundColor: "#4caf50",
        color: "white",
        boxShadow: "0 2px 8px rgba(76,175,80,0.4)",
        "&:hover": { backgroundColor: "#43a047" },
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
    },
    btnLimpar: {
        borderRadius: 25,
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
    },
}))

const STATUS_OPTIONS = [
    { value: "", label: "Todos" },
    { value: "0", label: "Em andamento" },
    { value: "1", label: "Completa" },
    { value: "-1", label: "Expirada" },
    { value: "2", label: "Resgatada" },
]

export function FiltrosCartelas() {
    const classes = useStyles()
    const { dados, dispatch, buscar } = useCartelasFornecedorContext()
    const [aberto, setAberto] = useState(true)

    const campo = (campo: keyof FiltroCartelas, label: string, tipo?: string) => (
        <Grid item xs={12} sm={6} md={4}>
            <TextField
                label={label}
                variant="outlined"
                size="small"
                fullWidth
                type={tipo || "text"}
                value={dados.filtro[campo]}
                onChange={e =>
                    dispatch({
                        type: CartelasFornecedorActionsTypes.ATUALIZAR_FILTRO_CAMPO,
                        payload: { campo, valor: e.target.value },
                    })
                }
                InputLabelProps={tipo === "date" ? { shrink: true } : undefined}
            />
        </Grid>
    )

    const handlePesquisar = () => {
        buscar(dados.filtro, 0)
    }

    const handleLimpar = () => {
        dispatch({ type: CartelasFornecedorActionsTypes.LIMPAR_FILTRO })
    }

    return (
        <Paper className={classes.card}>
            <Box className={classes.cardHeader} onClick={() => setAberto(v => !v)}>
                <Typography className={classes.cardHeaderTitle}>Filtros de Busca</Typography>
                {aberto ? <ExpandLess /> : <ExpandMore />}
            </Box>

            <Collapse in={aberto}>
                <Box className={classes.cardContent}>
                    <Grid container spacing={2}>
                        {campo("inicio", "Período início", "date")}
                        {campo("fim", "Período fim", "date")}
                        {campo("parteNome", "Nome do cliente")}
                        {campo("email", "E-mail")}

                        <Grid item xs={12} sm={6} md={4}>
                            <TextField
                                label="Status"
                                variant="outlined"
                                size="small"
                                fullWidth
                                select
                                value={dados.filtro.status}
                                onChange={e =>
                                    dispatch({
                                        type: CartelasFornecedorActionsTypes.ATUALIZAR_FILTRO_CAMPO,
                                        payload: { campo: "status", valor: e.target.value },
                                    })
                                }
                            >
                                {STATUS_OPTIONS.map(opt => (
                                    <MenuItem key={opt.value} value={opt.value}>
                                        {opt.label}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                    </Grid>

                    <Box className={classes.botoes}>
                        <Button
                            variant="contained"
                            className={classes.btnPesquisar}
                            startIcon={<Search />}
                            onClick={handlePesquisar}
                        >
                            Pesquisar
                        </Button>
                        <Button
                            variant="outlined"
                            className={classes.btnLimpar}
                            startIcon={<Clear />}
                            onClick={handleLimpar}
                        >
                            Limpar
                        </Button>
                    </Box>
                </Box>
            </Collapse>
        </Paper>
    )
}
